
import React from 'react';

interface ArticleLeadProps {
  lead?: string;
}

const ArticleLead = ({ lead }: ArticleLeadProps) => {
  if (!lead) return null;
  
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-0">
      <div className="my-6 text-lg md:text-xl font-medium italic border-l-4 border-primary pl-4">
        {lead}
      </div>
    </div>
  );
};

export default ArticleLead;
